/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
// TODO: Add proper types for API response data to eliminate unsafe operations
import { UserPersonalDetails } from './types'

export function mapPersonalDetailsResponse(data: any): UserPersonalDetails {
  return {
    ...data,
    email: data.email,
    address: data.address ? data.address : undefined,
    birthDate: data.birthDate ? data.birthDate : undefined,
    carRegistrationNumber: data.carRegistrationNumber
      ? data.carRegistrationNumber
      : undefined,
    city: data.city ? data.city : undefined,
    county: data.county ? data.county : undefined,
    postcode: data.postcode ? data.postcode : undefined,
    telephone: getTelephoneData(data.telephone),
  }
}

function getTelephoneData(telephone: any): UserPersonalDetails['telephone'] {
  const countryDialingCode = telephone?.countryDialingCode
    ? telephone.countryDialingCode
    : ''
  const countryDialingNumber = telephone?.countryDialingNumber
    ? telephone.countryDialingNumber
    : ''
  return {
    ...telephone,
    countryDialingCode,
    countryDialingNumber,
  }
}
